import { Box, BoxProps, createPolymorphicComponent } from "@mantine/core"
import { DefaultTheme } from "src/theme/theme"
import styled from "styled-components"
import logo from 'src/assets/logo.png';

type LogoWrapperProps = {
    $height: string
}

const _LogoWrapper = styled(Box) <LogoWrapperProps>`
    display: inline-block;
    padding: 1px;
    background-color: white;
    border-radius: 50%;
    & img {
        border-radius: 50%;
        display: block;
        @media (max-width: ${DefaultTheme.breakpoints.sm}) {
            height: 50px;
        }
        @media (min-width: ${DefaultTheme.breakpoints.sm}) {
            height: ${props => props.$height}px;
        }
    }
`

const LogoWrapper = createPolymorphicComponent<'div', BoxProps & LogoWrapperProps>(_LogoWrapper)

export function BookwellLogo({
    height = '28'
}: React.PropsWithChildren<{height?:string}>
): React.ReactElement {
    
    return (
        <LogoWrapper
            c="black"
            $height={height}
        >
            <a href="/" title="Bookwell"><img src={logo} height={height} alt="Bookwell Logo" /></a>
        </LogoWrapper>
    )

}